import React from "react";
import { useProjects } from "../../../api/useProjects";
import ProjectNavBar from "../../Project/NavBar";
import { useLocation, useParams } from "react-router";

export const ProjectHeaderNav = () => (
  <React.Suspense>
    <LocalProjectNav />
  </React.Suspense>
);

const LocalProjectNav = () => {
  const location = useLocation();
  const { projectId } = useParams();
  const project = useProjects().find(p => p.id === projectId);

  return project ? <ProjectNavBar reactiveProp={location.pathname} project={project} /> : null;
};
